import Checkbox from 'zarm/lib/checkbox';

Checkbox.defaultProps.prefixCls = 'zw-checkbox';
Checkbox.Group.defaultProps.prefixCls = 'zw-checkbox-group';

export default Checkbox;
